var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"root",staticClass:"period-selector"},[_c('FilterBtn',{attrs:{"disabled":_vm.disabled}},[(_vm.currentStartEndDate)?[_vm._v("\n      "+_vm._s(_vm.currentStartEndDate)+"\n    ")]:_c('Skeleton',{attrs:{"width":"87px"}})],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }